var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _circle, _ellipse, _circle2, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "#F8F9FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 32,
    width: 80,
    height: 64,
    rx: 8,
    fill: "#6741C6",
    fillOpacity: 0.1,
    stroke: "#6741C6",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 32,
    width: 80,
    height: 8,
    rx: 2,
    fill: "#6741C6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 48,
    width: 64,
    height: 12,
    rx: 2,
    fill: "#6741C6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 68,
    width: 40,
    height: 8,
    rx: 2,
    fill: "#6741C6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 84,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#6741C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 86V98C104 100.209 102.209 102 100 102H28C25.7909 102 24 100.209 24 98V86H104Z",
    fill: "#6741C6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 48,
    r: 8,
    fill: "#6741C6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96,
    cy: 48,
    rx: 4,
    ry: 5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 48,
    r: 2,
    fill: "#6741C6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 68,
    width: 16,
    height: 8,
    rx: 2,
    fill: "#6741C6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 84,
    width: 20,
    height: 4,
    rx: 1,
    fill: "#6741C6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 84,
    width: 20,
    height: 4,
    rx: 1,
    fill: "#6741C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewInvestment);
export default __webpack_public_path__ + "static/media/view-investment.fad649e58e88a1d421e19925def32bc2.svg";
export { ForwardRef as ReactComponent };